import { Props as ChipProps } from 'ui/elements/Chip';
import { BackofficeMatchmakingBaseMatch } from 'types/backoffice';
import { norwegianDateWithTimestamp } from 'util/dateUtils';
import { investorTypes } from 'types/user';

export const stateToColor: { [key in BackofficeMatchmakingBaseMatch['state']]: ChipProps['color'] } = {
  Staged: 'yellow',
  Yay: 'green',
  Seen: 'grey',
  Notified: 'grey',
  New: 'green-medium',
};

export function asDate(date: string | null | undefined): string {
  return date ? norwegianDateWithTimestamp(new Date(date)) : '-';
}

export function asInvestorType(key: string) {
  const entry = investorTypes[key];
  return entry ? entry.name : '-';
}
